const e = {
  "ld.startEditing": "Begin met bewerken.",
  "ld.dashboard": "Mijn dashboard",
  "ld.search": "Zoeken",
  "ld.browse": "Bladeren",
  "ld.reset": "Reset",
  "ld.searchResource": "Zoeken",
  "ld.create": "Hulpbron Aanmaken",
  "ld.edit": "Editie",
  "ld.editResource": "Bewerk bron",
  "ld.main": "Hoofd",
  "ld.and": "EN",
  "ld.or": "OF",
  "ld.not": "NIET",
  "ld.saveRd": "Opslaan",
  "ld.closeRd": "Bron sluiten",
  "ld.deleteRd": "Bron verwijderen",
  "ld.resources": "Hulpmiddelen",
  "ld.searchBy": "Zoeken op",
  "ld.searchFor": "Zoeken",
  "ld.searchAndFilter": "Zoeken & filteren",
  "ld.enterSearchCriteria": "Vul zoekcriteria in om te beginnen met zoeken",
  "ld.chooseFilterOrEnterSearchQuery": "Kies een filter of voer een Zoekquery in om resultaten te tonen.",
  "ld.searchNoRdsMatch": "Geen enkele omschrijving komt overeen met uw zoekopdracht",
  "ld.searchBySth": "Zoeken op{by}...",
  "ld.errorFetching": "Fout bij het ophalen van gegevens",
  "ld.errorLoadingResource": "Fout bij het invoeren van de bron",
  "ld.actions": "Acties",
  "ld.isbnLccn": "ISBN/LCCN",
  "ld.isbn": "ISBN",
  "ld.lccn": "LCCN",
  "ld.lcnaf": "LCNAF",
  "ld.title": "Titel",
  "ld.contributor": "Bijdrager",
  "ld.author": "Auteur",
  "ld.pubDate": "Publicatiedatum",
  "ld.pubDateShort": "Pub Datum",
  "ld.edition": "Editie",
  "ld.select": "Selecteren",
  "ld.subclass": "Subklasse",
  "ld.heading": "Heading",
  "ld.selectForEditing": "Selecteer een bronbeschrijving om te bewerken",
  "ld.startFromScratch": "Vanaf nul beginnen",
  "ld.selectOrStartFromScratch": "{select} of {startFromScratch}",
  "ld.backToTop": "Terug naar boven",
  "ld.preview": "Voorbeeld",
  "ld.confirmCloseRd": "Wilt u de resourcebeschrijving echt sluiten? Alle niet-opgeslagen wijzigingen zullen verloren gaan.",
  "ld.confirmDeleteRd": "Wilt u de resourcebeschrijving echt verwijderen?",
  "ld.saveClose": "Opslaan en sluiten",
  "ld.close": "Sluit",
  "ld.delete": "Verwijder",
  "ld.return": "Stuur  terug.",
  "ld.rdSaveSuccess": "Hulpmiddel aangemaakt. Verwacht een korte vertraging voordat het middel zichtbaar is in FOLIO.",
  "ld.rdUpdateSuccess": "Bron bijgewerkt. Verwacht een korte vertraging voordat wijzigingen zichtbaar zijn in FOLIO.",
  "ld.cantSaveRd": "Kan de beschrijving van de bron niet opslaan",
  "ld.cantDeleteRd": "Kan de resourcebeschrijving niet verwijderen",
  "ld.rdDeleted": "Beschrijving van bron verwijderd",
  "ld.appFail": "Er heeft zich een fout voorgedaan. Laad de pagina opnieuw.",
  "ld.searchSelectIndex": "Selecteer een index",
  "ld.advancedSearch": "Geavanceerd zoeken",
  "ld.advanced": "Geavanceerd",
  "ld.cancel": "Annuleren",
  "ld.loading": "Invoer...",
  "ld.paginationCount": "{startCount} - {endCount} van {totalResultsCount}",
  "ld.yes": "Ja",
  "ld.no": "Geen",
  "ld.cantLoadSimpleLookupData": "Kan gegevens voor een eenvoudig Opzoeken niet invoeren",
  "ld.publishDate": "Uitgever",
  "ld.format": "Format",
  "ld.suppressed": "Onderdrukt",
  "ld.notSuppressed": "Niet onderdrukt",
  "ld.volume": "Volume",
  "ld.ebook": "eBook",
  "ld.allTime": "Altijd",
  "ld.past12Months": "Afgelopen 12 maanden",
  "ld.past10Yrs": "Afgelopen 10 jaar",
  "ld.past5Yrs": "Afgelopen 5 jaar",
  "ld.customRange": "Maatwerk",
  "ld.all": "Alle",
  "ld.onlineResource": "Online hulpbron",
  "ld.startsWith": "Begint met",
  "ld.containsAll": "Bevat alle",
  "ld.exactPhrase": "Exacte zin",
  "ld.publisher": "Uitgever",
  "ld.creator": "Schepper",
  "ld.language": "Taal",
  "ld.classificationNumber": "Classificatienummer",
  "ld.work": "Werk",
  "ld.instances": "Instanties",
  "ld.noInstancesAvailable": "Geen instances beschikbaar.",
  "ld.noInstancesAdded": "Geen Instances Toevoegen",
  "ld.addAnInstance": "Een Instance Toevoegen",
  "ld.type": "Soorten",
  "ld.expandAll": "Alles uitbreiden",
  "ld.collapseAll": "Alles inklappen",
  "ld.showAllWithCount": "Toon alle ({amt})",
  "ld.showAdditionalComponents": "Extra onderdelen weergeven ({amt})",
  "ld.hideAdditionalComponents": "Verberg extra onderdelen",
  "ld.hide": "Verbergen",
  "ld.saveAndClose": "Opslaan & sluiten",
  "ld.saveAndContinue": "Opslaan & doorgaan",
  "ld.editInstance": "Instance bewerken",
  "ld.editWork": "Werk bewerken",
  "ld.createInstance": "Instance aanmaken",
  "ld.createWork": "Werk aanmaken",
  "ld.saveAndKeepEditing": "Opslaan & verder gaan met bewerken",
  "ld.recordMappingToSchema": "Kan een record niet toepassen op het schema",
  "ld.newResource": "Nieuwe bron",
  "ld.addInstance": "Instance toevoegen",
  "ld.compareSelected": "Selecteren vergelijken",
  "ld.newInstance": "Nieuw Instance",
  "ld.newWork": "Nieuw werk",
  "ld.new": "Nieuw",
  "ld.cantSelectReferenceContents": "Kan geen referentie-inhoud selecteren tijdens het ophalen van een referentie",
  "ld.addNewInstance": "Nieuwe instance toevoegen",
  "ld.askSaveChangesBeforeProceeding": "Wilt u uw wijzigingen Opslaan voordat u verder gaat?",
  "ld.unsavedRecentEdits": "Recente wijzigingen in de bron zijn niet opgeslagen. Niet-opgeslagen wijzigingen gaan verloren.",
  "ld.unsavedChanges": "Niet-opgeslagen wijzigingen",
  "ld.continueWithoutSaving": "Verder zonder op te slaan",
  "ld.noTitleInBrackets": "Geen titel",
  "ld.viewMarc": "MARC bekijken",
  "ld.marcWithTitle": "MARC - {title}",
  "ld.cantLoadMarc": "Kan MARC voor deze bronbeschrijving niet invoeren",
  "ld.duplicate": "Dupliceren",
  "ld.viewLinkedData": "Gekoppelde gegevens bekijken",
  "ld.viewInInventory": "Bekijk in Collectiebezit app",
  "ld.authorityType": "Type Auteur",
  "ld.person": "Persoon",
  "ld.source": "Bron",
  "ld.family": "Familie",
  "ld.organization": "Organisatie",
  "ld.meeting": "Vergadering",
  "ld.corporateBody": "Bedrijfsorgaan",
  "ld.jurisdiction": "Bevoegdheid",
  "ld.conference": "Conferentie",
  "ld.authorizedReference": "Auteur/referentie",
  "ld.headingReference": "Heading/Verwijzing",
  "ld.unauthorized": "Ongeautoriseerd",
  "ld.assign": "Toewijzen",
  "ld.assignAuthority": "Autoriteit toewijzen",
  "ld.change": "Verander",
  "ld.searchCreatorAuthority": "Auteur autoriteit zoeken",
  "ld.selectMarcAuthority": "Selecteer MARC authority",
  "ld.marcAuthority": "Authority MARC",
  "ld.keyword": "Trefwoord",
  "ld.recordsFound": "{recordsCount} records gevonden",
  "ld.resourceWithIdIsEmpty": "Beschrijving van de bron {id} leeg is",
  "ld.duplicateInstance": "Instantie dupliceren",
  "ld.duplicateWork": "Dupliceren",
  "ld.duplicateInstanceInBrackets": "(INSTANTIE DUPLICEREN)",
  "ld.duplicateWorkInBrackets": "(DUPLICEER WERK)",
  "ld.identifierAll": "Identificatiekenmerk (alle)",
  "ld.personalName": "Persoon",
  "ld.corporateName": "Naam bedrijf/conferentie",
  "ld.geographicName": "Geografische naam",
  "ld.nameTitle": "Titel",
  "ld.uniformTitle": "Uniform title",
  "ld.subject": "Onderwerp",
  "ld.childrensSubjectHeading": "Onderwerp Kinderen",
  "ld.genre": "Genre",
  "ld.authoritySource": "Auteur bron",
  "ld.references": "Referenties",
  "ld.thesaurus": "Thesaurus",
  "ld.typeOfHeading": "Soorten rubrieken",
  "ld.dateCreated": "Datum aangemaakt",
  "ld.dateUpdated": "Datum Update",
  "ld.excludeSeeFrom": "See exclude from",
  "ld.excludeSeeFromAlso": "See from also uitsluiten",
  "ld.previous": "Vorige",
  "ld.next": "Volgende",
  "ld.from": "Van",
  "ld.to": "Naar",
  "ld.apply": "Toepassen",
  "ld.notSpecified": "Niet gespecificeerd",
  "ld.externalResourcePreview": "Voorbeeld van externe bronnen",
  "ld.errorFetchingExternalResourceForPreview": "Fout bij het ophalen van externe bron voor voorbeeld",
  "ld.fetchingExternalResourceById": "Externe bron ID ophalen {resourceId}...",
  "ld.lastUpdated": "Laatst bijgewerkt",
  "ld.marcAuthorityRecord": "MARC authority record",
  "ld.selectBrowseOption": "Selecteer een bladeroptie",
  "ld.searchQueryWouldBeHere": "{query} hier zou zijn",
  "ld.continue": "Verder",
  "ld.aria.filters.select": "Zoek Identificatiekenmerken Selecteren",
  "ld.aria.filters.textbox": "Tekstvak Zoekquery",
  "ld.aria.filters.reset": "Knop Reset filters",
  "ld.aria.filters.reset.announce": "Zoeken en filters worden opnieuw ingesteld",
  "ld.backToInventory": "Terug naar Collectiebezit",
  "ld.properties": "Eigenschappen",
  "ld.errorFetchingExternalResourceForEditing": "Fout bij het ophalen van externe bron voor bewerking",
  "ld.duplicateImportWarn": "Waarschuwing voor dubbel importeren",
  "ld.rdPropertiesMatchContinue": "Eigenschappen van deze bron komen overeen met een bestaande bron. Wilt u verder gaan?",
  "ld.instance": "Instance",
  "ld.year": "Jaar",
  "ld.aria.modal.close": "Sluit {modalKind} modal",
  "ld.aria.advancedSearch.queryInput": "Geavanceerde zoekrij query-invoer",
  "ld.aria.advancedSearch.operator": "Geavanceerde zoekrij operator",
  "ld.aria.advancedSearch.qualifier": "Geavanceerd zoeken op rij Kenmerk",
  "ld.aria.advancedSearch.identifier": "Geavanceerd zoeken rij-identificatiekenmerk",
  "ld.aria.listEntry.open": "Inklapbare lijst openen",
  "ld.aria.listEntry.close": "Inklapbare lijst sluiten",
  "ld.aria.table.selectRow": "Tabelrij selecteren",
  "ld.aria.sections.openResourcePreview": "Open het voorvertoningsgedeelte van bronnen",
  "ld.aria.sections.closeResourcePreview": "Bronnenvoorbeeld sluiten",
  "ld.aria.edit.close": "Pagina voor bewerken sluiten",
  "ld.aria.edit.deleteComponent": "Component verwijderen",
  "ld.aria.edit.duplicateComponent": "Dupliceer component",
  "ld.aria.resourcePreview.close": "Venster met voorbeeld van bronnen sluiten",
  "ld.aria.externalResourcePreview.close": "Voorbeeldpagina externe bronnen sluiten",
  "ld.aria.marcAuthorityPreview.close": "Auteur sluiten MARC preview",
  "ld.aria.marcPreview.close": "Modal MARC voorbeeld sluiten",
  "ld.aria.complexLookup.marcPreview.close": "Opzoeken MARC preview sectie sluiten",
  "ld.aria.edit.removeComplexLookupFieldValue": "Complexe veldwaarde Opzoeken verwijderen",
  "ld.errorMakingApiRequest": "Fout bij het maken van een API-aanvraag",
  "ld.compareResources": "Vergelijk bronnen",
  "ld.selectedResources": "Geselecteerde bronnen",
  "ld.nResourcesSelected": "{n} geselecteerde bronnen",
  "ld.clearSelections": "Selecties wissen",
  "ld.chooseTwoResourcesCompare": "Kies twee of meer bronnen om te vergelijken",
  "ld.chooseOneResourceCompare": "Kies een andere bron om te vergelijken",
  "ld.aria.comparison.close": "Vergelijking sluiten",
  "ld.aria.comparison.removeEntry": "Vergelijking verwijderen",
  "ld.aria.searchPane.close": "Venster Zoeken sluiten",
  "ld.aria.searchPane.open": "Venster Zoeken openen",
  "ld.modal.uncontrolledAuthoritiesWarning.title": "Waarschuwing ongecontroleerde authoriteiten",
  "ld.modal.uncontrolledAuthoritiesWarning.body": `Deze beschrijving bevat een of meer ongecontroleerde Authorities.
 Wilt u wijzigingen opslaan?`,
  "ld.errorAssigningAuthority": "Fout bij het toewijzen van autoriteit",
  "ld.errorAssigningAuthority.not_valid_for_target": "Selecteer een autoriteit met een type bron dat overeenkomt met het bewerkte veld van de autoriteit (bijv. LCNAF autoriteit voor het veld Creator)",
  "ld.errorAssigningAuthority.no_lccn": "Op dit moment kunnen alleen Authoriteiten van de Library of Congress worden toegewezen. Dit is tijdelijk totdat aanvullende brontypen worden ondersteund.",
  "ld.errorAssigningAuthority.unsupported_marc": "De geselecteerde autoriteit is niet gekoppeld aan Linked Data en kan nog niet worden toegewezen. Dit is tijdelijk, aangezien de MARC mapping bezig is.",
  "ld.required_primary_main_title": "Voeg de hoofdtitel toe om op te slaan.",
  "ld.lccn_does_not_match_pattern": "LCCN Patroonvalidatie ingeschakeld: Geef een LCCN op die voldoet aan de standaardstructuur.",
  "ld.lccn_not_unique": "LCCN uniciteit ingeschakeld: De LCCN die u hebt opgegeven bestaat al. Geef een ander LCCN op.",
  "ld.failed_dependency": "Kan niet controleren of LCCN gedupliceerd is.",
  "ld.not_found": "Het ID van de bron is gewijzigd door een andere gebruiker terwijl u deze bron open had staan. Vernieuw het venster van uw browser.",
  "ld.mapping": "Er heeft zich een probleem voorgedaan met de mapping. Rapport dit alstublieft aan uw supportteam, met schermafbeeldingen en een gedetailleerd verslag van wat er is gebeurd.",
  "ld.generic_bad_request": "Er heeft zich een UI probleem voorgedaan. Rapport dit alstublieft aan uw supportteam, met schermafbeeldingen en een gedetailleerd verslag van wat er is gebeurd.",
  "ld.server": "Er is een probleem met de server. Rapport dit alstublieft aan uw supportteam, met schermafbeeldingen en een gedetailleerd verslag van wat er is gebeurd.",
  "ld.already_exists": "The same resource ID already exists.",
  "ld.aria.sections.editInstance": "Edit instance: {title}"
};
export {
  e as default
};
